export const LANDING = '/';
export const HOME = '/home';
export const CREW = '/crew';
export const ANNOUNCEMENTS = '/announcements';
export const SCREENING = '/screening';